<div class="page-wrapper">
  <div class="page-section start" [ngClass]="{ darkMode: this.config?.theme === 'dark-mode' }">

    <div class="vertical-aligned-textblock">
      <h1>Contact me</h1>
      <p class="basic-text-style-large">{{ this.contact_info?.name }}<br />{{ this.contact_info?.function }}
        <br />{{ this.contact_info?.address }}<br />{{ this.contact_info?.address_line2 }}</p>
    </div>

    <div class="contact-details contact-page" id="contact-page-details">
      <div class="email buttonEl" (click)="linkTo('mailto:' + this.contact_info?.email)">
        <p class="email-text buttonEl">Email</p>
        <span class="email-text mail buttonEl">{{ this.contact_info?.email }}<div class="arrow-link buttonEl"></div></span>
      </div>
      <ul class="social-media-list contact">
        <li class="buttonEl" *ngFor="let item of this.contact_info?.social_media" (click)="linkTo(item.url)">
          {{ item.name }}
        </li>
      </ul>
    </div>
    <div id="svgBg"></div>
  </div>
</div>
